module.exports = __webpack_public_path__ + "img/rhombus.28bccec2.svg";